import type { TFunction } from 'i18next';

/** Translated reason of a failed (or incomplete) analysis — never raw backend text. */
export function overviewFailureMessage(t: TFunction, errorCode: string | null | undefined): string {
  switch (errorCode) {
    case 'AI_BUDGET_EXCEEDED':
      return `${t('aiUsage.exceededNoDate')} ${t('aiUsage.supportHint')}`;
    case 'AI_TEMPORARILY_UNAVAILABLE':
      return t('aiUsage.unavailable');
    case 'TIMEOUT':
      return t('livestockOverview.failed.timeout');
    default:
      return t('livestockOverview.failed.generic');
  }
}

/** A date in the UI language, e.g. "10 Oct 2026" / "10.10.2026". */
export function formatOverviewDate(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(language || undefined, { dateStyle: 'medium' }).format(date);
  } catch {
    return date.toISOString().slice(0, 10);
  }
}

/** Credits with at most one decimal in the UI language. */
export function formatCredits(value: number, language: string): string {
  try {
    return new Intl.NumberFormat(language || undefined, { maximumFractionDigits: 1 }).format(value);
  } catch {
    return String(Math.round(value * 10) / 10);
  }
}

/** Today's date in the user's time zone as YYYY-MM-DD (the date the animals are added). */
export function localIsoDate(now: Date = new Date()): string {
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
